import * as UserActions from './actions'

/** Estado inicial del usuario. @type {*} */
export const initialState: object = {
  id: null,
  name: '',
  roles: [],
  flast_name: null,
  country_code: null,
  phone: null,
  permissions: [],
  corporates: [],
  email: '',
  avatar: '',
  url: '',
  authorized: false,
  loading: false,
}

/**
 * Reducer para usuarios.
 *
 * @param {*} [state=initialState]
 * @param {UserActions.Actions} action
 * @return {*}  {object}
 */
export function reducer(state = initialState, action: UserActions.Actions): object {
  switch (action.type) {
    case UserActions.LOGIN:
    case UserActions.REGISTER:
    case UserActions.LOAD_CURRENT_ACCOUNT:
      return {
        ...state,
        loading: true,
      }
    case UserActions.LOGIN_SUCCESSFUL:
    case UserActions.REGISTER_SUCCESSFUL:
    case UserActions.LOAD_CURRENT_ACCOUNT_SUCCESSFUL:
    case UserActions.UPDATE_USER:
      return {
        ...state,
        ...action.payload,
        loading: false,
        authorized: true,
      }
    case UserActions.LOGIN_UNSUCCESSFUL:
    case UserActions.REGISTER_UNSUCCESSFUL:
    case UserActions.LOAD_CURRENT_ACCOUNT_UNSUCCESSFUL:
      return {
        ...state,
        loading: false,
        authorized: false,
      }
    case UserActions.FLUSH_USER:
    case UserActions.EMPTY_ACTION:
      return initialState
    default:
      return state
  }
}

/**
 * Reducer para obtener un usuario.
 *
 * @param {*} state
 */
export const getUser = (state: any) => state
